
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h22v22H0z"}}),_c('circle',{attrs:{"cx":"11","cy":"11","r":"11","fill":"#1351f9"}}),_c('path',{attrs:{"fill":"#FFF","d":"M9.471 14.969l-3.948-3.314a.667.667 0 1 1 .857-1.021l3.577 3.002 6.368-6.368a.667.667 0 0 1 .943.943l-6.808 6.808a.667.667 0 0 1-.989-.05z"}})])])
      }
    
      }
    